<script>
import { uniqueId } from 'lodash-es';
import { PhxIcon } from '@phx-styleguides/jlc';

export default {
  components: { PhxIcon },

  props: {
    hasArrow: {
      type: Boolean,
      default: true,
    },
    isTouchEnabled: {
      type: Boolean,
      default: true,
    },
    image: {
      type: Object,
      default: null,
    },
    offset: {
      type: Number,
      default: 10,
    },
    placement: {
      type: String,
      default: 'top-center',
    },
    title: {
      type: String,
      default: null,
    },
  },

  computed: {
    uniqueId() {
      return uniqueId('tooltip-');
    },
    contentId() {
      return this.uniqueId + '-content';
    },
  },

  mounted() {
    new Toolkit.Tooltip(this.$refs.tooltip, {
      placement: this.placement,
      enableTouch: this.isTouchEnabled,
      enableArrow: this.hasArrow,
      offset: this.offset,
    });
  },
};
</script>

<template>
  <div :id="uniqueId" ref="tooltip" class="tooltip tooltip checkbox__tooltip tooltip--minimal">
    <div class="tooltip__trigger" :aria-describedby="contentId">
      <slot>
        <button
          type="button"
          class="btn btn--default btn--xs btn--icon-only btn--icon"
          :aria-label="$t('Accessibility.tooltip.trigger.ariaLabel')"
        >
          <span class="sr-only">
            <slot name="label">
              {{ $t('Tooltip.discoverMore') }}
            </slot>
          </span>

          <span class="btn__icon">
            <phx-icon icon="info-16" bidirectional />
          </span>
        </button>
      </slot>
    </div>

    <div :id="contentId" class="tooltip__content" role="tooltip">
      <slot name="content">
        <template v-if="title">{{ title }}</template>
      </slot>
    </div>
  </div>
</template>
